import { FastQuestionTranslation } from '@/assets/locales/views/employeeProfile/sections/chat/employeeProfile.chat.translation.en.ts';

export const employeeProfileChatFastQuestionsOwnerTranslation: FastQuestionTranslation = {
  fastQuestionButtons: {
    question1: 'Mój rozwój',
    question2: 'Dopasowanie projektów',
    question3: 'Kompetencje do rozwoju',
    question4: 'Ścieżka awansu',
    question5: 'Cele rozwojowe',
    question6: 'Materiały edukacyjne',
    question7: 'Plan działania',
  },
  fastQuestionTexts: {
    question1: 'Jak mogę się rozwijać na moim obecnym stanowisku?',
    question2: 'W jakich projektach mogę najlepiej wykorzystać swoje umiejętności?',
    question3: 'Jakie kompetencje warto rozwijać w pierwszej kolejności?',
    question4: 'Jakie kroki muszę podjąć, żeby awansować na wyższe stanowisko?',
    question5: 'Jakie cele rozwojowe warto sobie wyznaczyć na najbliższe miesiące?',
    question6: 'Jakie kursy, książki lub szkolenia mogą wspomóc mój rozwój?',
    question7: 'Jak stworzyć konkretny plan rozwoju zawodowego?',
  },
};
